import * as yup from "yup";
import { kanaAlpNum } from "../utility/ValidationUtilty";

export type User = {
  id: string;
  tenantId: string;
  lastName?: string;
  firstName?: string;
  lastNameKana?: string;
  firstNameKana?: string;
  birthDate?: Date;
  sex?: number;
  phoneNumber?: string;
  faxNumber?: string;
  iconURL?: string;
  familyEmail?: string;
  tag?: string[];
  groupCount?: number;
  devicesCount?: number;
  createAt: Date;
  updateAt: Date;
  admin?: boolean;
  deleteFlg?: boolean;
  note?: string;
  accountSuspensionFlg: boolean;
  deleteAt?: Date | null;
  displayId?: string;
  qrData?: any;
}

export const UserItemMaping = (data: any | undefined): User | UserData => {
  data.familyEmail = data?.familyEmail !== undefined
    ? data?.familyEmail.join(",")
    : "";
  data.birthDate = data?.birthDate !== null
    ? new Date(data?.birthDate?.seconds * 1000)
    : data?.birthDate;
  data.createAt = new Date(data?.createAt?.seconds * 1000);
  data.updateAt = data?.updateAt !== null
    ? new Date(data?.updateAt.seconds * 1000)
    : new Date();
  return data;
}

export const initialUserInfo: User = {
  id: "",
  tenantId: "",
  lastName: "",
  firstName: "",
  lastNameKana: "",
  firstNameKana: "",
  birthDate: undefined,
  sex: 0,
  phoneNumber: "",
  faxNumber: "",
  iconURL: "",
  familyEmail: "",
  tag: [],
  groupCount: 0,
  devicesCount: 0,
  createAt: new Date(),
  updateAt: new Date(),
  admin: false,
  deleteFlg: false,
  note: "",
  accountSuspensionFlg: false,
  deleteAt: null,
}

export type UserData = User & {
  groups: GroupsSetting[],
  salt: string | null,
  encryptedPasscode: string | null,
  decryptedPasscode: string | null,
  password: string | null,
  passcode: string | null,
  iv: Blob | null
};

export const initialUserDataInfo: UserData = {
  id: "",
  tenantId: "",
  lastName: "",
  firstName: "",
  lastNameKana: "",
  firstNameKana: "",
  birthDate: undefined,
  sex: 0,
  phoneNumber: "",
  faxNumber: "",
  iconURL: "",
  familyEmail: "",
  tag: [],
  groupCount: 0,
  devicesCount: 0,
  createAt: new Date(),
  updateAt: new Date(),
  admin: false,
  salt: "",
  password: "",
  passcode: "",
  encryptedPasscode: "",
  decryptedPasscode: "",
  iv: new Blob(),
  deleteFlg: false,
  note: "",
  groups: [],
  accountSuspensionFlg: false,
  deleteAt: null,
}

export enum ColorList {
  "blue" = 0,
  "green" = 1,
  "red" = 2,
  "yellow" = 3,
  "indigo" = 4,
  "purple" = 5,
  "pink" = 6,
  "gray" = 7
}

export type GroupsSetting = {
  id: string;
  name: string;
  color: "blue" | "green" | "red" | "yellow" | "indigo" | "purple" | "pink" | "gray";
  disabled?: boolean | null | undefined;
}

export const userSchema = yup.object({
  lastName: yup.string().required(),
  lastNameKana: kanaAlpNum,
  deleteFlg: yup.boolean().required(),
})

export type Devices = {
  id:string;
  token: string;
  timeStamp: Date;
}

export type AttendingGroups = {
  id: string;
  userId: string;
  tenantId: string;
}

export type Password = {
  id: string;
  userId: string;
  password: string;
  createAt: Date;
}

export type Passcode = {
  id: string;
  userId: string;
  encryptedPasscode: string;
  createAt: Date;
}

export type Iv = {
  id: string;
  userId: string;
  iv: Blob;
  createAt: Date;
}

export type ReadMessages = {
  messageId: string;
  userId: string;
  readAt?: Date;
  replyAt?: Date;
  replyButtonName: string;
}

export type UserCountList = {
  idRegistered: number;
  usable: number;
  unusable: number;
  suspended: number;
};